import { AddNewMicromarketModal } from "molecules/Modals/AddNewMicromarketModal";
import React from "react";

import MasterTemplateTable from "templates/Master/MasterTemplateTable";
import api from "utils/api";

const Micromarket = () => {
  return (
    <MasterTemplateTable
      actions={{
        get: async () => {
          try {
            const { data } = await api("/micromarkets/get", {
              method: "get",
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        create: async ({ name, locationId, linkedMicromarkets, isPopular }) => {
          try {
            const reqData = {
              name,
              locationId,
              linkedMicromarkets,
              isPopular: !!isPopular,
            };
            const { data } = await api("/micromarkets/add", {
              method: "post",
              data: reqData,
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        update: async (
          id,
          { name, locationId, linkedMicromarkets, isPopular }
        ) => {
          try {
            const reqData = {
              name,
              locationId,
              linkedMicromarkets,
              isPopular: !!isPopular,
            };
            const { data } = await api(`/micromarkets/update/${id}`, {
              method: "put",
              data: reqData,
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        remove: async (id) => {
          try {
            const { data } = await api(`/micromarkets/delete/${id}`, {
              method: "delete",
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
      }}
      pageHeading="Micromarket"
      addRecord="Add Micromarket"
      searchRecord="Search Micromarket"
      table={{
        tableHeader: [
          {
            name: "Name",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
          {
            name: "Location",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
          {
            name: "Actions",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
        ],
        tableRowDatas: [
          {
            render: (record) => <td>{record?.name}</td>,
          },
          {
            render: (record) => <td>{record?.locations?.name}</td>,
          },
        ],
        actions: { editable: true, removable: true },
      }}
      // actionModal={{ title: "Micromarket", isLocation: true }}
      actionModal={{
        title: "Micromarket",
        CustomModal: AddNewMicromarketModal,
      }}
    />
  );
};

export default Micromarket;
